import { useState } from "react";

/**
 * Logo da seguradora com fallback textual.
 *
 * Os arquivos vivem em `web/public/logos/<codigo>.png` (azos e mag hoje). O
 * `onError` cai num badge com as iniciais — vale pra seguradora nova que entre
 * no catálogo antes de alguém subir a arte, e pra imagem que não carregue.
 *
 * Mora em arquivo próprio porque é usado na grade de escolha (PassoSeguradoras)
 * e no acompanhamento do fan-out (ProgressoCotacao) — e o fallback só vale se
 * as duas telas caírem no mesmo.
 */
export const LogoSeguradora = ({
  codigo,
  nome,
  tamanho = "md",
  sozinha = false,
}: {
  codigo: string;
  nome: string;
  /** xs cabe dentro de uma badge de tabela; sm no acompanhamento; md na grade de escolha. */
  tamanho?: "xs" | "sm" | "md";
  /**
   * Logo SEM o nome escrito ao lado — o caso das tabelas e dos filtros, onde a
   * arte das duas seguradoras já é a palavra da marca. Aí o nome vai no `alt`,
   * senão leitor de tela não recebe nada.
   */
  sozinha?: boolean;
}) => {
  const [falhou, setFalhou] = useState(false);
  const classe =
    tamanho === "xs" ? "h-4 w-4 text-[8px]" : tamanho === "sm" ? "h-7 w-7 text-[11px]" : "h-10 w-10 text-sm";
  const altura = tamanho === "xs" ? "h-4" : tamanho === "sm" ? "h-7" : "h-10";

  if (falhou) {
    return (
      <span
        className={`flex shrink-0 items-center justify-center rounded-full bg-primary/10 font-bold text-primary ${classe}`}
      >
        {nome.slice(0, 2).toUpperCase()}
      </span>
    );
  }
  return (
    // Com o nome escrito ao lado o alt fica vazio de propósito: duplicar faria
    // leitor de tela dizer "Azos Azos".
    <img
      src={`/logos/${codigo}.png`}
      alt={sozinha ? nome : ""}
      className={`${altura} w-auto shrink-0 object-contain`}
      onError={() => setFalhou(true)}
    />
  );
};
